import Button from 'components/Button/Button';
import PubSwitcherLogo from 'components/PubSwitcherLogo/PubSwitcherLogo';
import SettingsDropdown from 'components/SettingsDropdown/SettingsDropdown';
import {useGlobalState} from 'hooks/useGlobalState';
import {isAdmin} from 'utils/helpers/getUserRoles';

import './NavbarContent.scss';

interface IProps {
  setShowPubSwitcher: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function NavbarContent({setShowPubSwitcher}: IProps) {
  const {user} = useGlobalState((state) => state.app);

  return (
    <div data-testid="navbar-content" className="dashboard-navbar-content">
      {!isAdmin(user!) && (
        <Button
          variant="empty"
          title="switch pub"
          className="dashboard-navbar-content__switcher"
          data-testid="navbar-content-toggler"
          onClick={() => setShowPubSwitcher((prevState) => !prevState)}
        >
          <PubSwitcherLogo />
        </Button>
      )}
      <SettingsDropdown />
    </div>
  );
}
